import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { submitRequest } from './submitRequest';
import {
  DefaultResponse,
  WatchdogResultItem,
  WatchdogTypePossibilities,
} from '@mercedes-benz/pmas-common';

export class WatchdogApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(discoveryApi: DiscoveryApi, fetchApi: FetchApi) {
    this.discoveryApi = discoveryApi;
    this.fetchApi = fetchApi;
  }

  async getStats(): Promise<DefaultResponse<any>> {
    return submitRequest({
      discoveryApi: this.discoveryApi,
      fetchApi: this.fetchApi,
      method: 'GET',
      path: `/watchdog/stats`,
    });
  }

  async getWatchdogSearch(
    type: WatchdogTypePossibilities,
    query: string,
  ): Promise<DefaultResponse<WatchdogResultItem[]>> {
    return submitRequest({
      discoveryApi: this.discoveryApi,
      fetchApi: this.fetchApi,
      method: 'GET',
      path: `/watchdog/search/${type}/${query}`,
    });
  }
}
